import { useEffect, useState } from 'react';
import { findEntry, listLibrary } from '@/api/library';
import { useAuth } from '@/context/AuthContext';

/**
 * The signed-in reader's purchase of this book — whichever version of it they
 * hold — so its page can say "you own this" instead of offering to sell it again.
 *
 * `entry` is undefined while it is being looked up, and null when they hold no
 * purchase of it (or are signed out, or the platform could not be asked — the
 * page then simply offers the book, and checkout refuses a second copy anyway).
 */
export function useOwnedCopy(product) {
  const { isSignedIn } = useAuth();
  const [entry, setEntry] = useState(undefined);
  const productId = product?.id;
  const lineageId = product?.lineage_id;

  useEffect(() => {
    if (!productId || !isSignedIn) {
      setEntry(null);
      return undefined;
    }
    const controller = new AbortController();
    setEntry(undefined);
    listLibrary({ signal: controller.signal })
      .then((entries) => setEntry(findEntry(entries, { id: productId, lineage_id: lineageId })))
      .catch((err) => {
        if (err.name !== 'AbortError') setEntry(null);
      });
    return () => controller.abort();
  }, [productId, lineageId, isSignedIn]);

  return entry;
}
